// extracted by mini-css-extract-plugin
export default {"priceList":"Show_priceList__XOalU","seatDote":"Show_seatDote__uAlLl"};